{
    "lang": { "khmer": "km", "english": "en" },
    "language": { "km": "Khmer", "en": "English", "fi": "Finnish" },
    "region": { "khmer": "KH", "english": "US" },
    "flag": { "km": "🇰🇭", "en": "🇺🇸", "fi": "🇫🇮" },
    "khmer": { "km": "ខ្មែរ", "en": "Khmer", "fi": "Khmer" },
    "english": { "km": "អង់គ្លេស", "en": "English", "fi": "Englanti" },
    "finnish": { "km": "ភាសាហ្វាំងឡង់", "en": "Finnish", "fi": "Suomi" },

    "close": { "km": "បិទ", "en": "Close" },
    "popup": {
        "km": "សូមអនុញ្ញាតឲ្យបង្អួចលេចឡើង។",
        "en": "Please allow popup"
    },

    "login1": { "km": "", "en": "" },
    "login2": { "km": "សូមបញ្ចូលអ៊ីមែល", "en": "Please enter your email" },
    "login3": {
        "km": "សូមបញ្ចូលឡើងវិញអ៊ីមែល",
        "en": "Please re-enter your email"
    },
    "login4": { "km": "ផ្ញើតំណរភ្ជាប់អ៊ីមែល", "en": "Send Email Link" },
    "login5": {
        "km": "ដើម្បីបច្ចុប្បន្នភាពអាសយដ្ឋានអ៊ីមែលរបស់អ្នក សូមបើកតំណរភ្ជាប់ពីឧបករណ៍ ឬកម្មវិធីរុករកដដែលដែលអ្នកបានចាប់ផ្តើមជាមួយ ប្រសិនបើមិនបាន សូមចូលឡើងវិញនៅទីនេះ ហើយព្យាយាមម្តងទៀត។",
        "en": "To update your email address, please open the link from the same device or browser you started with, or login again here and try again."
    },
    "login6": {
        "km": "សូមបើករកមើលកូដនៅក្នុងអ៊ីមែលរបស់អ្នក",
        "en": "Code sent to your email! Please check your inbox or spam folder."
    },
    "login7": {
        "km": "អ្នកបានចូលប្រើដោយជោគជ័យហើយ!",
        "en": "You have successfully logged in!"
    },
    "login8": {
        "km": "អ្នកបានចូលប្រើដោយជោគជ័យហើយ! អ្នកអាចបិទបង្អួចនេះបានឥឡូវនេះ។",
        "en": "You have successfully logged in! You may now close this window."
    },
    "login9": {
        "km": "សូមរង់ចាំ...",
        "en": "Please wait..."
    },

    "signin": { "km": "គណនី", "en": "Log In" },
    "signin1": { "km": "អ៊ីមែល", "en": "Your Email" },
    "signin2": { "km": "លេខកូដបណ្តោះអាសន្ន", "en": "Temporary Code" },
    "signin3": { "km": "សុំលេខកូដ", "en": "Get Code" },
    "signin4": { "km": "បញ្ជូនមតិយោបល់", "en": "Submit" },
    "signin5": { "km": "បង្ហាញ", "en": "Show" },
    "signin6": { "km": "លាក់", "en": "Hide" },
    "signin7": { "km": "ផ្ញើកូដថ្មី", "en": "Send New Code" }
}
